import styled from 'styled-components';

export const DashboardCardLabelBlock = styled.div`
  text-align: left;
  padding-bottom: 10px;
  display: inline-block;
`;

export const DashboardCardHeading = styled.label`
  display: inline-block;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #b0bec5;

  &:hover {
    cursor: pointer;
  }
`;
